<template>
    <!-- 导航 -->
    <NavBar
        class="nav"
        bgcolor="#529A9E"
    >
        <template v-slot:title>
            <span class="nav-title">藏品详情</span>
        </template>
    </NavBar>

    <header>
        <div class="img-box">
            <img src="" alt="" />
        </div>
    </header>

    <main class="bg-color">
        <div class="detail-box">
            <div class="name">嗨嗨啊嗨</div>
            <div class="xl-list">
                <span class="item">
                    <img src="@/assets/images/lock.png" alt="" />
                    购买即可体验内容
                </span>
                <span class="right-text">限量 2568 份</span>
            </div>
        </div>

        <div class="attention">
            <div class="left-content">
                <img src="" alt="" />
                <section>
                    <p class="text-title">嗨嗨嗨</p>
                    <p class="text-num">作品：哈哈哈</p>
                </section>
            </div>

            <div class="right-btn">关注</div>
        </div>

        <div class="text-content">
            <div class="left-cont">
                <p class="title">66</p>
                <p class="cont">围观(人)</p>
            </div>
            <div class="right-cont">
                <p class="title">66</p>
                <p class="cont">预约(人)</p>
            </div>
        </div>

        <div class="tips-title-cp">藏品介绍</div>

        <div class="field-container">
            <div class="field-content" id="cangpinIMG">
                <div class="cp-detail">
                    <div class="cangpin-content">
                        <img src="" />
                    </div>
                    <!-- <div class="cp-info">
              <div>发行方</div>
              <div class="publish"></div>
            </div> -->
                </div>
            </div>
        </div>

        <div class="tips-title-cp">系列盲盒</div>

        <div class="mystery-box">
            <van-row type="flex" gutter="10" justify="space-between">
                <van-col span="12">
                    <router-link to="/" class="box">
                        <img class="cover" src="" />
                        <div class="content">
                            <p class="title ellipsis2"><span>¥</span> 188</p>
                            <div class="btn">开启盲盒</div>
                        </div>
                    </router-link>
                </van-col>
                <van-col span="12">
                    <router-link to="/" class="box">
                        <img class="cover" src="" />
                        <section class="content">
                            <p class="title ellipsis2"><span>¥</span> 188</p>
                            <div class="btn">开启盲盒</div>
                        </section>
                    </router-link>
                </van-col>
                <van-col span="12">
                    <router-link to="/" class="box">
                        <img class="cover" src="" />
                        <section class="content">
                            <p class="title ellipsis2"><span>¥</span> 188</p>
                            <div class="btn">开启盲盒</div>
                        </section>
                    </router-link>
                </van-col>
                <van-col span="12">
                    <router-link to="/" class="box">
                        <img class="cover" src="" />
                        <section class="content">
                            <p class="title ellipsis2"><span>¥</span> 188</p>
                            <div class="btn">开启盲盒</div>
                        </section>
                    </router-link>
                </van-col>
            </van-row>
        </div>

        <div class="tips-title-cp">藏品信息</div>

        <div class="field-container">
            <div class="field-content" id="cangpinIMG2">
                <div class="field">
                    <div class="field-ri">
                        <div class="field-author">品牌方</div>
                        <div class="field-name publisher-name">章三</div>
                    </div>
                    <div class="field-ri">
                        <div class="field-author">发行方</div>
                        <div class="field-name publisher-name">新华树藏</div>
                    </div>
                    <div class="field-ri">
                        <div class="field-author">发行日期</div>
                        <div class="field-name publisher-name">
                            3126553 32:53
                        </div>
                    </div>
                    <div class="field-ri">
                        <div class="field-author">主题编号</div>
                        <div class="field-name publisher-name">
                            24685121654321
                        </div>
                    </div>
                    <div class="field-ri">
                        <div class="field-author">艺术品ID</div>
                        <div class="field-name publisher-name">
                            asdfa21sdf2a31d2f1asf
                        </div>
                    </div>
                    <div class="field-ri">
                        <div class="field-author">所在链</div>
                        <div class="field-name publisher-name">长安链</div>
                    </div>
                    <div class="field-ri">
                        <div class="field-author">链ID</div>
                        <div class="field-name publisher-name">322</div>
                    </div>
                    <div class="field-ri field-ri-end">
                        <div class="field-author">发行日期</div>
                        <div class="field-name fx-date">111111111111</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底层链技术 -->
        <img class="xhl-logo" src="@/assets/images/xhl-logo.png" alt="" />
    </main>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>